import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useLocalAuthoritiesForDropdowns } from "../hooks/localAuthorities/useLocalAuthoritiesForDropdowns";

const LocalAuthorityContext = createContext(null);

export function LocalAuthorityProvider({ children }) {
  const [enabledDropdownFetch, setEnabledDropdownFetch] = useState(false);

  const dropdownFetch = useLocalAuthoritiesForDropdowns({ filters: {}, enabled: enabledDropdownFetch });

  const enableDropdownFetch = useCallback(() => {
    setEnabledDropdownFetch(true);
  }, []);

  const value = useMemo(
    () => ({
      dropdownFetch: {
        data: dropdownFetch.data,
        isLoading: dropdownFetch.isLoading,
        error: dropdownFetch.error,
        refetch: dropdownFetch.refetch,
        isRefetching: dropdownFetch.isRefetching,
        enableDropdownFetch,
      },
    }),
    [
      dropdownFetch.data,
      dropdownFetch.isLoading,
      dropdownFetch.error,
      dropdownFetch.refetch,
      dropdownFetch.isRefetching,
      enableDropdownFetch,
    ]
  );

  return <LocalAuthorityContext.Provider value={value}>{children}</LocalAuthorityContext.Provider>;
}

export function useLocalAuthorityContext() {
  const context = useContext(LocalAuthorityContext);

  if (!context) {
    throw new Error("useLocalAuthorityContext must be used inside LocalAuthorityContext");
  }

  return context;
}
